import React, { useEffect, useState } from 'react';
import './profitTable.css'; // Custom CSS for better UI
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment/moment';
import Form from 'react-bootstrap/Form';
import Loader from "../../components/loader/loader";
import Spinner from 'react-bootstrap/Spinner';





// const sampleData = [
//   {
//     branch: 'KARIMNAGAR',
//     grossProfit: 28351,
//     discount: 2247,
//     expenses: 16774,
//     gst: 3584,
//     netProfit: 5746,
//     subData: [
//       { item: 'Phone', amount: 4000 },
//       { item: 'Accessory', amount: 1746 }
//     ]
//   },
//   {
//     branch: 'VIJAYAWADA 3',
//     grossProfit: 358,
//     discount: 0,
//     expenses: 16774,
//     gst: 49,
//     netProfit: -16465,
//     subData: [
//       { item: 'Phone', amount: 0 },
//       { item: 'Charger', amount: 0 }
//     ]
//   },
//   // Add more rows if needed
// ];

const ProfitTable = () => {
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [expandedRows, setExpandedRows] = useState([]);
  const [dateArray, setDateArray] = useState([]);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [checked, setChecked] = useState(false);
  const [startDate, endDate] = dateRange;
  const [dayWiseLoader, setDayWiseLoader] = useState(false);
  const [intialLoader,setInitialLoader]=useState(true);
  const [reportLoader,setReportLoader]=useState(false)


  useEffect(() => {
    if (startDate && endDate) {
      generateDates();
      getProfitReportData()
    }

  }, [startDate, endDate, checked])

  const onSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    const sortedData = [...data].sort((a, b) => {
      return direction === 'asc' ? a[key] - b[key] : b[key] - a[key];
    });
    setSortConfig({ key, direction });
    setData(sortedData);
  };

  const toggleExpand = (index) => {
    setExpandedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const getProfitReportData = async () => {
    try {
      if(new Date(startDate).getMonth()==new Date(endDate).getMonth()){
       let response = await axios(`https://mis-api.happimobiles.com/api/profitability/profitTargetsAdmin?from=${startDate}&to=${endDate}`);
      let result = await response.data.data;
      // console.log("result", result);
      setData(result.map((item => ({ ...item, subData: [] }))));
      setInitialLoader(false)
      if (checked&&new Date(startDate).getMonth()==new Date(endDate).getMonth()) {
        getProfitReportDateWise()
      }
      }
      else{
        return toast.error("Please Select Same Month")
      }
      

    }
    catch (e) {
      toast.error('Network Error')
    }

  }
  const getProfitReportDateWise = async () => {
    let dates = generateDates()
    setDayWiseLoader(true);
    for (let i = 0; i < dates.length; i++) {
      const filterDate=moment(dates[i]).add(1, 'days').format("YYYY-MM-DD") 
      try {
        let response = await axios(`https://mis-api.happimobiles.com/api/profitability/profitTargetsAdmin?from=${filterDate}&to=${filterDate}`);
        let result = await response.data.data;
        setData(prev => (prev.map(item => ({ ...item, subData: [...item?.subData, { ...result.find(dayItem => dayItem.branch_name.includes(item.branch_name)), appliedDate: dates[i] }] }))))
      }
      catch (e) {
        if(checked&&new Date(startDate).getMonth()!=new Date(endDate).getMonth()){
           return toast.error("Please select Same Month")
        }
        toast.error('Network Error')
      }
    }
    setDayWiseLoader(false);
  }

  const generateDates = () => {
    const dates = getDatesInRange(startDate, endDate);
    setDateArray(dates);
    return dates
  };


  const downloadCSV = () => {
    setReportLoader(true)
    
    let csvContent = '';
    
    if (checked && data.some(item => item.subData && item.subData.length > 0)) {
      // Include day-wise data when checkbox is checked and subData exists
      const mainHeaders = ['Branch Name', 'Gross Profit', 'Total Discount', 'Expenses', 'Total GST', 'Net Profit'];
      const dayWiseHeaders = ['Branch Name', 'Date', 'Gross Profit', 'Total Discount', 'Expenses', 'Total GST', 'Net Profit'];
      
      // Main data rows
      const mainRows = data.map(row => [
        row.branch_name,
        row.gross_profit,
        row.total_discount,
        row.expenses,
        row.total_gst,
        row.net_profit
      ]);
      
      // Day-wise data rows
      const dayWiseRows = [];
      data.forEach(row => {
        if (row.subData && row.subData.length > 0) {
          row.subData.forEach(dayData => {
            dayWiseRows.push([
              row.branch_name,
              moment(dayData.appliedDate).add(1, 'days').format('DD-MM-YYYY'),
              dayData.gross_profit || 0,
              dayData.total_discount || 0,
              dayData.expenses || 0,
              dayData.total_gst || 0,
              dayData.net_profit || 0
            ]);
          });
        }
      });
      
      // Combine main data and day-wise data
      csvContent = [
        'SUMMARY DATA',
        mainHeaders.join(','),
        ...mainRows.map(row => row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(',')),
        '',
        'DAY-WISE DATA',
        dayWiseHeaders.join(','),
        ...dayWiseRows.map(row => row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(','))
      ].join('\n');
      
    } else {
      // Original logic for main data only
      const filteredData = data.map(({ subData, ...rest }) => rest);
      const headers = Object.keys(filteredData[0]).join(',');
      const rows = filteredData.map(row =>
        Object.values(row)
          .map(value => `"${String(value).replace(/"/g, '""')}"`)
          .join(',')
      );
      
      csvContent = [headers, ...rows].join('\n');
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    
    // Generate filename based on date range and whether day-wise is included
    const startDateStr = moment(startDate).format('DD-MM-YYYY');
    const endDateStr = moment(endDate).format('DD-MM-YYYY');
    const filename = checked ? 
      `profit_report_${startDateStr}_to_${endDateStr}_with_daywise.csv` :
      `profit_report_${startDateStr}_to_${endDateStr}.csv`;
    
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setReportLoader(false)
  };

  const getDatesInRange = (start, end) => {
    const date = new Date(start);
    const dates = [];

    while (date <= new Date(end)) {
      dates.push(new Date(date).toISOString().split('T')[0]);
      date.setDate(date.getDate() + 1);
    }

    return dates;
  };




  return (
    <>
   {
    intialLoader?<Loader/>: <div className="profit-table-container">
      <h3 className='text-center text-uppercase' style={{ letterSpacing: "4px" }}>Profit</h3>
      <div className='d-flex w-100 mb-2 justify-content-between px-2'>
        <div className='w-50 d-flex align-items-center gap-1'>
          <DatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => {
              setDateRange(update);
            }}
            maxDate={new Date()}
            className="w-75 h-100 "
          />
          <Form.Check // prettier-ignore
            type={"checkbox"}
            id={`default-check`}
            label={`Day-Wise`}
            checked={checked}
            className='text-nowrap'
            onChange={(e) => setChecked(e.target.checked)}
          />

        </div>
        <div className=''>
          <button className='btn btn-success' onClick={downloadCSV}>{reportLoader?<Spinner animation="border" />:"Get Report"}</button>
        </div>
      </div>

      <table className="profit-table">
        <thead>
          <tr>
            <th onClick={() => onSort('branch')}>Branch Name</th>
            <th onClick={() => onSort('gross_profit')}>Gross Profit</th>
            <th onClick={() => onSort('discount')}>Total Discount</th>
            <th onClick={() => onSort('expenses')}>Expenses</th>
            <th onClick={() => onSort('total_gst')}>Total GST</th>
            <th onClick={() => onSort('net_profit')}>Net Profit</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <React.Fragment key={idx}>
              <tr
                onClick={() => toggleExpand(idx)}
                className={`main-row ${row?.net_profit >= 0 ? 'profit' : 'loss'}`}
              >
                <td>{row?.branch_name}</td>
                <td>₹{row?.gross_profit?.toLocaleString()}</td>
                <td>₹{row?.total_discount?.toLocaleString()}</td>
                <td>₹{row?.expenses?.toLocaleString()}</td>
                <td>₹{row?.total_gst?.toLocaleString()}</td>
                <td className="net-profit">₹{row?.net_profit?.toLocaleString()}</td>
              </tr>

              {checked&&expandedRows.includes(idx) && (
                <tr className="expanded-row">
                  <td colSpan="6">
                    <strong>Details:</strong>
                    <table className="sub-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th onClick={() => onSort('gross_profit')}>Gross Profit</th>
                          <th onClick={() => onSort('discount')}>Total Discount</th>
                          <th onClick={() => onSort('expenses')}>Expenses</th>
                          <th onClick={() => onSort('total_gst')}>Total GST</th>
                          <th onClick={() => onSort('net_profit')}>Net Profit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {row.subData.map((item, subIdx) => (
                          <tr key={subIdx}>
                            <td>{moment(item.appliedDate).add(1, 'days').format('DD-MM-YYYY')}</td>
                            <td>₹{item?.gross_profit?.toLocaleString()}</td>
                            <td>₹{item?.total_discount?.toLocaleString()}</td>
                            <td>₹{item?.expenses?.toLocaleString()}</td>
                            <td>₹{item?.total_gst?.toLocaleString()}</td>
                            <td className="net-profit">₹{item?.net_profit?.toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
   }
    
    </>
   
  );
};

export default ProfitTable;
